import { FloatingNavigationOpenMenuButton } from "@src/appV2/redesign/components/FloatingNavigation/OpenMenuButton";
import {
  FloatingNavigationTab,
  FloatingNavigationTabs,
} from "@src/appV2/redesign/components/FloatingNavigation/Tabs";
import { useState } from "react";
import { useFloatingTabs } from "../../../../appV2/redesign/AppLayout/Mobile/FloatingTabsContext";
import { AppLayoutPageWrapperMobile } from "@src/appV2/redesign/AppLayout/Mobile/PageWrapperMobile";
import { AppLayoutWrapperMobile } from "./Wrapper";
import { NavigationMenuDrawerMobile } from "./Navigation/NavigationMenuDrawer";
import { NavigationMenuHeaderMobile } from "./Navigation/NavigationMenuHeader";
import { NavigationMenuFooterMobile } from "./Navigation/NavigationMenuFooter";
import { NavigationMenuItemsMobile } from "./Navigation/NavigationMenuItems";
import { NavigationMenuItemsContainerMobile } from "@src/appV2/redesign/AppLayout/Mobile/Navigation/NavigationMenuItemsContainer";
import { Box } from "@mui/material";
import { AllRoutes } from "../Shared/Navigation/routes/AllRoutes";

export interface AppLayoutMobileProps {
  admin: boolean;
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  logoutConfirm: () => void;
  renderStartPage: () => JSX.Element | null;
}

function Divider() {
  return (
    <Box
      sx={(theme) => ({
        height: "1px",
        backgroundColor: theme.palette.navbar?.sectionDivider,
      })}
    />
  );
}

export function AppLayoutMobile(props: AppLayoutMobileProps) {
  const { admin, isAdmin, isWorker, isWorkplace, logoutConfirm, renderStartPage } = props;

  const [showSidenav, setShowSidenav] = useState(false);
  const { tabs, showTabs, activeTab, setActiveTab } = useFloatingTabs();

  return (
    <AppLayoutWrapperMobile>
      <NavigationMenuDrawerMobile
        open={showSidenav}
        onClose={() => {
          setShowSidenav(false);
        }}
      >
        <NavigationMenuHeaderMobile
          onClose={() => setShowSidenav(false)}
          logoutConfirm={() => {
            setShowSidenav(false);
            logoutConfirm();
          }}
        />

        <Divider />

        <NavigationMenuItemsContainerMobile>
          <NavigationMenuItemsMobile
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            closeSidenav={() => setShowSidenav(false)}
          />
        </NavigationMenuItemsContainerMobile>

        <Divider />

        <NavigationMenuFooterMobile />
      </NavigationMenuDrawerMobile>

      <AppLayoutPageWrapperMobile>
        <AllRoutes
          admin={admin}
          isAdmin={isAdmin}
          isWorker={isWorker}
          isWorkplace={isWorkplace}
          renderStartPage={renderStartPage}
        />
      </AppLayoutPageWrapperMobile>

      {tabs.length > 0 && showTabs && (
        <FloatingNavigationTabs
          value={activeTab}
          onChange={(_, newValue) => {
            setActiveTab(newValue as string);
            const tab = tabs.find((t) => t.value === newValue);
            if (tab?.onClick) {
              tab.onClick();
            }
          }}
        >
          {tabs.map((tab) => (
            <FloatingNavigationTab
              key={tab.value}
              iconType={tab.iconType}
              label={tab.label}
              value={tab.value}
            />
          ))}
        </FloatingNavigationTabs>
      )}

      <FloatingNavigationOpenMenuButton
        onClick={() => {
          setShowSidenav(true);
        }}
      />
    </AppLayoutWrapperMobile>
  );
}
